/**
 * @Author: Colin Osterhout <ctosterhout>
 * @Date:   2018-05-04T14:16:12-08:00
 * @Email:  ctosterhout@alaska.edu
 * @Last modified by:   ctosterhout
 * @Last modified time: 2020-10-07T22:34:07-08:00
 * @License: Released under MIT License. copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
 */

import _ from 'lodash'
import urlMangle from './url-mangle'

// ----------------------------------------------------------------------------
// Default Menu data
// ----------------------------------------------------------------------------
/* eslint-disable indent */
const defaultNavItems = [{
  type: 'dropdown',
  title: 'About',
  menu: [{
      title: 'About ACRC',
      href: '/about/index.html'
    },
    {
      title: 'People',
      href: '/about/people.html'
    },
    {
      title: 'Contact Us',
      href: '/about/contact.html'
    },
    {
      title: 'Get Involved',
      href: '/about/get-involved.html'
    }
  ]
}, {
  type: 'dropdown',
  title: 'Research',
  menu: [{
      title: 'Research Overview',
      href: '/projects/index.html'
    },
    {
      title: 'Stream Dynamics',
      href: '/projects/stream-dynamics/index.html'
    },
    {
      title: 'Land Ecosystems',
      href: '/projects/land-ecosystems/index.html'
    },
    {
      title: 'Ocean Resources',
      href: '/projects/ocean-resources/index.html'
    },
    {
      title: 'Glacier Dynamics',
      href: '/projects/glacier-dynamics/index.html'
    },
    {
      title: 'Coastal Linkages',
      href: '/projects/coastal-linkages/index.html'
    },
    {
      title: 'Adaptive Governance',
      href: '/projects/adaptive-governance/index.html'
    }
  ]
}, {
  type: 'dropdown',
  title: 'News',
  menu: [{
      title: 'Recent Articles',
      href: '/articles/index.html'
    },
    {
      title: 'Archive',
      href: '/articles/archive.html'
    }
  ]
}, {
  type: 'dropdown',
  title: 'Field Blog',
  menu: [{
      title: 'From the Field',
      href: '/blog/index.html'
    }
  ]
}, {
  type: 'dropdown',
  title: 'Resources',
  menu: [{
      title: 'Publications',
      href: '/publications/index.html'
    },
    {
      title: 'Videos',
      href: '/videos.html'
    },
    {
      title: 'Logos',
      href: '/logos.html'
    }
  ]
}]
/* eslint-enable indent */

// Function to mangle menu descriptors by prefixing the href if we're in staging
const mangleMenuDescriptor = (menuDescriptor) => {
  const mangleMenuHrefs = (menu) => {
    return _.map(menu, (menuItem) => ({
      ...menuItem,
      href: urlMangle(menuItem.href)
    }))
  }

  return {
    ...menuDescriptor,
    menu: mangleMenuHrefs(menuDescriptor.menu)
  }
}

// Process menu items to prepend the staging directory if necessary
export default _.map(defaultNavItems, mangleMenuDescriptor)
